import {t} from "i18next";

export const calculateSlotStatus = (slot, selectedRows) => {
    const totalPaidForLength = () => {
        return selectedRows.reduce((total, row) => total + (row.paid_for_length || 0), 0);
    };

    const availableSits = slot.available_sits || 0;

    if (availableSits === 0) {
        return {
            status: 'no_seats',
            text: t('common.forms.movePaymentModal.noSeats'),
            color: 'danger',
            className: 'row__transfer_danger'
        };
    } else if (availableSits >= totalPaidForLength()) {
        return {
            status: 'transfer',
            text: t('common.forms.movePaymentModal.move'),
            color: 'success',
            className: 'row__transfer_success'
        };
    } else {
        return {
            status: 'partial_transfer',
            text: t('common.forms.movePaymentModal.partialTransfer'),
            color: 'secondary',
            className: 'row__transfer_secondary'
        };
    }
};

export const sortSlotsByStatus = (slots, selectedRows) => {
    const statusPriority = {
        'transfer': 1,
        'partial_transfer': 2,
        'no_seats': 3
    };

    return [...slots].sort((a, b) => {
        const firstSlotStatus = calculateSlotStatus(a, selectedRows).status;
        const secondSlotStatus = calculateSlotStatus(b, selectedRows).status;
        return statusPriority[firstSlotStatus] - statusPriority[secondSlotStatus];
    });
};